<template>
  <!-- 模板 -->
  <div class="container" >
    <content-template>
      <template slot="left">線上常識問答比賽</template>
      <template slot="right">
        <li class="media-navbar">
          <a class="is-check">線上常識問答比賽</a>
        </li>
        <li class="media-navbar">
          <a @click="nameList" style="cursor: pointer">賽事名單公佈</a>
        </li>
        <li class="media-navbar media-navbar-none-margin nav-float-left">
          <a @click="allQuestion" style="cursor: pointer">過往題目</a>
        </li>
      </template>
      <template slot="banner">
        <img src="./banner.jpg" class="top-banner" style="position: relative;" alt="">
        <div class="match-count-down" v-show="noPost" v-if="timeLimit > 0"><img src="./count-down.png" alt=""><span id="product-sec-countdown">0:00</span></div>
      </template>
      <template slot="content" v-if="!isSuccess">
        <div class="col-xs-12 content-list" style="margin-top: -30px">
          <div class="hidden-xs content-number">
            <ul>
              <li v-for="(question,index) in questions"><span :class="current.hasOwnProperty('key'+index) ? 'choose' : ''">{{index+1}}</span></li>
            </ul>
          </div>
          <!--网页版题目样式-->
          <div class="hidden-xs col-sm-11 content-question">
            <div class="question-detail clearfix" v-for="(question,index) in questions">
              <div class="col-xs-12 col-sm-6 the-ipad-min">
                {{index+1}}. <span v-html="question.questionText"></span>
                <img style="max-width: 100%" v-if="question.attachment" :src="question.attachment" alt="">
              </div>
              <div class="col-xs-12 col-sm-6 the-ipad-min">
                <a v-for="(answer,aIndex) in question['answers']" class=" question-option" @click="optionCheck(index,answer.id)"
                   :class="{'active': current['key'+index] == answer.id, 'aaa': chekcAnswer(current['key'+index],'key'+index,answer.id),'bbb':rightAnswer['key'+index] == answer.id,'ccc': !noPost}"
                :style="{'cursor': noPost ? 'pointer' : 'default'}">
                  <template v-if="aIndex == 0">A</template>
                  <template v-else-if="aIndex == 1">B</template>
                  <template v-else-if="aIndex == 2">C</template>
                  <template v-else-if="aIndex == 3">D</template>
                  . <span v-html="answer.optionText"></span><img style="max-width: 100%" v-if="answer.attachment" :src="answer.attachment" alt="">
                </a>
              </div>
            </div>

            <div class="col-xs-6 " v-if="noPost">
              <button class="btn-complete" @click="showAlert">完成</button>
            </div>
            <div class="col-xs-6 " :style="{'text-align': noPost ? '' : 'right'}">
              <button class="btn-back" @click="goBack">返回</button>
            </div>
          </div>
          <!--手机版题目样式-->
          <div class="visible-xs content-question">
            <div class="question-detail clearfix" v-if="!showAnswer">
              <div class="col-xs-12 none-padding">
                <span style="color: #5571EC">{{qKey+1}}/{{qLenght}}</span>
                {{qKey+1}}. <span v-html="oneQuestion.questionText"></span>
                <img style="max-width: 100%" v-if="oneQuestion.attachment" :src="oneQuestion.attachment" alt="">
              </div>
              <div  v-for="(answer,aIndex) in oneQuestion.answers"  class="col-xs-12" style="z-index: 0">
                <a class="question-option" @click="optionCheck(qKey,answer.id)" style="pointer-events：none">
                  <template v-if="aIndex == 0">A</template>
                  <template v-else-if="aIndex == 1">B</template>
                  <template v-else-if="aIndex == 2">C</template>
                  <template v-else-if="aIndex == 3">D</template>
                  . <span v-html="answer.optionText"></span><img style="max-width: 100%" v-if="answer.attachment" :src="answer.attachment" alt="">
                </a>
              </div>
            </div>
            <div class="question-detail clearfix" v-if="showAnswer">
              <div class="question-detail clearfix" v-for="(question,index) in questions">
                <div class="col-xs-12 col-sm-6 the-ipad-min">
                  {{index+1}}
                </div>
                <div class="col-xs-12 col-sm-6 the-ipad-min">
                  <a v-for="(answer,aIndex) in question['answers']" class=" question-option" @click="optionCheck(index,answer.id)"
                     :class="{'active': current['key'+index] == answer.id, 'aaa': chekcAnswer(current['key'+index],'key'+index,answer.id),'bbb':rightAnswer['key'+index] == answer.id,'ccc': !noPost}"
                     :style="{'cursor': noPost ? 'pointer' : 'default'}">
                    <template v-if="aIndex == 0">A</template>
                    <template v-else-if="aIndex == 1">B</template>
                    <template v-else-if="aIndex == 2">C</template>
                    <template v-else-if="aIndex == 3">D</template>
                    . <span v-html="answer.optionText"></span><img style="max-width: 100%" v-if="answer.attachment" :src="answer.attachment" alt="">
                  </a>
                  <hr style="height: 2px;margin: 10px">
                </div>
              </div>
            </div>
            <div class="col-xs-6 " v-show="noPost">
              <button id="next-btn" class="btn-complete"  @click="nextQuestion">{{btnText}}</button>
            </div>
            <div class="col-xs-6 "  :style="{'margin-left': noPost ? '' : '25%'}">
              <button class="btn-back"  @click="goBack">返回</button>
            </div>
          </div>
        </div>
      </template>
      <template slot="content" v-if="isSuccess">
        <div class="enroll-success">
          提交題目成功 <br>
          <button @click="goBack">返回</button>
        </div>
      </template>
    </content-template>
    <message-code ref="alert" v-on:commitSuccess="isCommitSuccess"></message-code>
  </div>
</template>
<script>
import Vue from 'vue'
import contentTemplate from '../contentTemplate'
import messageCode from '../commonSense/messageCode.vue'
export default {
  components: {
    'content-template': contentTemplate,
    'message-code': messageCode
  },
  data () {
    return {
      current: [],
      questions: [],
      oneQuestion: [],
      rightAnswer: [],
      showRight: false,
      qKey: 0,
      qLenght: 0,
      btnText: '下一題',
      timeLimit: 0,
      pattern: 0,
      valid: true,
      noPost: true,
      countDownTime: null,
      showAnswer: false,
      isSuccess: false
    }
  },
  methods: {
    optionCheck: function (index, j) {
      if (this.valid === true && this.noPost) {
        Vue.set(this.current, 'key' + index, j)
      }
    },
    allQuestion: function () {
      this.$router.push({path: '/all-question'})
      clearInterval(this.countDownTime)
    },
    nameList: function () {
      this.$router.push({path: '/name-list'})
      clearInterval(this.countDownTime)
    },
    showAlert: function () {
      // console.log(this.current)
      if (this.pattern === 1) {
        this.$refs.alert.show(this.current)
      } else if (this.pattern === 2) {  // 游戏模式
        this.gameMode()
        if (document.body.clientWidth < 768) {
          this.showAnswer = true
        }
        // this.$refs.game.show(this.current)
        // this.isShow = false
      }
    },
    isCommitSuccess: function (commitSuccess) {
      this.isSuccess = commitSuccess
      var that = this
      setTimeout (function () {
        that.$router.push({name: 'common-sense'})
      }, 5000)
    },
    goBack: function () {
      this.$router.push({name: 'common-sense'})
    },
    // 游戏模式
    gameMode: function () {
      var that = this
      this.$axios({
        url: 'competition/game',
        method: 'post',
        data: this.$qs.stringify(this.current)
      })
        .then(function (response) {
          that.rightAnswer = response.data.data
          that.showRight = true
          that.noPost = false
          clearInterval(that.countDownTime)
          // console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    chekcAnswer: function (currentKey, key, answerId) {
      if (this.rightAnswer.hasOwnProperty(key)) {
        // 找出选择错误题目
        if (currentKey !== this.rightAnswer[key] && currentKey === answerId && this.showRight) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    // 获得题目
    getQuestion: function () {
      var that = this
      this.$axios.get('/competition')
        .then(function (response) {
          if (response.data.code === 1) {
            that.questions = response.data.data.compition.questions
            that.pattern = response.data.data.pattern
            that.oneQuestion = that.questions[0]
            that.qLenght = that.questions.length
            that.timeLimit = response.data.data.compition.time_limit
            if (that.timeLimit > 0) {
              that.$nextTick(() => {
                that.countdown(that.timeLimit * 60) // 结束时间到开始时间的时间差，单位秒
              })
            }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    nextQuestion: function () {
      if (this.qLenght - 1 === this.qKey + 1) {
        this.btnText = '提交'
      }
      if (this.valid === false) {
        this.showAlert()
      }
      if (this.qLenght <= this.qKey + 1) {
        this.showAlert()
      } else {
        this.qKey += 1
        this.oneQuestion = this.questions[this.qKey]
      }
    },
    goBack: function () {
      // this.current = []
      // this.rightAnswer = []
      // this.qKey = 0
      this.$router.push({path: '/common-sense'})
      clearInterval(this.countDownTime)
    },
    // 倒計時
    countdown (sec) {
      var that = this
      // timer = null
      setTimeout(function () {
        var hour = 0
        var minute = 0
        var second = 0
        that.countDownTime = setInterval(function () {
          if (sec >= 60) {
            minute = Math.floor(sec / 60)
            second = sec % 60
            if (minute >= 60) {
              hour = Math.floor(minute / 60)
              minute = minute % 60
            } else {
              hour = 0
            }
          } else {
            second = sec
            hour = 0
            minute = 0
          }
          hour = parseInt(hour) < 10 && parseInt(hour) > 0 ? '0' + hour : hour
          minute = parseInt(minute) < 10 && parseInt(minute) > 0 ? '0' + minute : minute
          second = parseInt(second) < 10 && parseInt(second) > 0 ? '0' + second : second
          var countdownStr = ''
          if (hour > 0) {
            countdownStr = hour + ':' + minute + ':' + second
          } else {
            countdownStr = minute + ':' + second
          }
          document.getElementById('product-sec-countdown').innerHTML = countdownStr
          sec--
          if (sec < 0) {
            document.getElementById('product-sec-countdown').innerHTML = '已結束'
            that.btnText = '提交'
            that.valid = false
            clearInterval(that.countDownTime)
          }
        }, 1000)
      }, 0)
    }
  },
  mounted () {
    this.goTop()
    this.getQuestion()
  },
  beforeDestroy () {
    clearInterval(this.countDownTime)
  }
}
</script>
<style scoped>
  .container {
    /*background: #FFFFFF;*/
    /*box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.50);*/
    /*border-radius: 5px;*/
    /*margin-top: 80px;*/
    /*min-height: 900px;*/
    padding: 0px;
  }

  .top .top-left img {
    margin-bottom: 5px;
  }

  .top .top-left span {
    font-size: 20px;
  }

  .top a{
    border: 2px solid rgba(0,0,0,0);
  }

  .top ul li {
    display: inline-block;
    /*margin-right: 20px;*/
    font-size: 20px;
  }

  .top ul li a {
    padding: 0px 5px;
    color: #565656;
  }

  .top ul li a:hover, .top ul li a:focus {
    border: 2px solid #5571EC;
    border-radius: 60px;
    color: #5571EC;
    text-decoration: none;
  }
  .match-count-down{
    position: absolute;
    top: 10%;
    width:140px;
    height:50px;
    background:rgba(248,231,28,1);
    box-shadow:0px 2px 4px 0px rgba(0,0,0,0.23);
    border-radius:0px 100px 100px 0px;
    text-align: center;
  }
  .match-count-down img{
    width: 40px;
    height: 40px;
    padding: 5px;
    border-radius: 40px;
    background-color: #FFFFFF;
    margin-bottom: 10px;
    margin-right: 10px;
  }
  .match-count-down span{
    display: inline-block;
    font-size: 23px;
    height: 50px;
    line-height: 50px;
  }
  .content .content-img{
    padding:0px;
    height: 255px;
  }
  .content .content-img img{
    width: 100%;
    height: 100%;
  }
  .content .content-list{
    padding: 0px;
    position: relative;
    margin-bottom: -40px;
    /*min-height: 760px;*/
  }
  .content .content-list .content-number{
    background: #DAEBFF;
    width: 60px;
    height: 100%;
    position: absolute;
    min-height: 745px;
    border-bottom-left-radius: 5px;
  }
  .content-number{
    margin-left: -15px;
  }
  .content-number ul{
    padding: 0px;
    text-align: center;
    list-style-type: none;
  }
  .content-number ul li span{
    display: inline-block;
    margin-top: 15px;
    width: 34px;
    height: 34px;
    border-radius: 34px;
    line-height: 34px;
    font-size: 18px;
    color: #ffffff;
    background: #C0C2C5;
  }

  .content-number .choose{
    background: #5571EC;
  }
  .content-question{
    margin-left: 70px;
  }
  .content-question .question-detail{
    padding-top: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #C0C2C5;
    font-size: 18px;
    color: #565656;
  }


  .content-question .question-detail .question-option{
    border: 2px solid rgba(0,0,0,0);
    display: inline-block;
    padding-left: 30px;
    padding-right: 5px;
    margin-bottom: 5px;
    margin-right: 5px;
    min-width: 20%;
    text-align: left;
    cursor: pointer;
    color: #000;
  }
  .question-option:hover,.question-option:focus{
    text-decoration: none;
  }
  .content-question .question-detail .question-option:hover,.content-question .question-detail .active{
    background-color: #5571EC;
    background: url("check-bule.png") left no-repeat;
    background-size: 28px;
    border: 2px solid #5571EC;
    border-radius: 50px;
  }
  .content-question  .btn-complete,.content-question .btn-back{
    margin-top: 30px;
    width: 140px;
    height: 35px;
    font-size: 20px;
    border-radius: 100px;
    background: #fff;
    cursor: pointer;
    margin-bottom: 40px;
  }
  .content-question  .btn-complete{
    border: 2px solid #5571EC;
    float: right;
  }
  .content-question .btn-back{
    border: 2px solid #C0C2C5;
  }

  .content-question .question-detail .ccc:hover{
    background-color: #ffffff;
    background: none;
    background-size: 28px;
    border: 2px solid #ffffff;
    border-radius: 50px;
    cursor: default;
  }
  .content-question .question-detail .aaa,.content-question .question-detail .aaa:hover {
    background-color: #D0021B;
    background: url("check-red.png") left no-repeat;
    background-size: 28px;
    border: 2px solid #D0021B;
    border-radius: 50px;
  }

  .content-question .question-detail .bbb,.content-question .question-detail .bbb:hover {
    background-color: #52C41A;
    background: url("check-green.png") left no-repeat;
    background-size: 28px;
    border: 2px solid #52C41A;
    border-radius: 50px;
  }

  @media (max-width: 767px) {
    .content-question{
      margin-left: 0px;
    }
    .content-question .question-detail{
      border-bottom: none;
    }
    .content-question .question-detail .question-option{
      margin-top: 20px;
      margin-bottom: 20px;
      margin-left: 30px;
    }
    .content .content-list .content-number{
      /*min-height: 300px;*/
    }

    .match-count-down{
      width:75px;
      height:30px;
    }
    .match-count-down img{
      width: 23px;
      height: 23px;
      padding: 2px;
      border-radius: 23px;
      margin-bottom: 2px;
      margin-right: 5px;
    }
    .match-count-down span{
      font-size: 14px;
      height: 30px;
      line-height: 30px;
    }

    .content-question .question-detail{
      padding-bottom: 0px;
    }

  }
  @media (max-width: 768px) {

    .top .top-right ul {
      margin: 0;
      padding: 0;
    }

    .top ul li {
      font-size: 16px;
    }
    /*.content-question .question-detail{*/
      /*font-size: 20px;*/
      /*!*border-bottom: none;*!*/
    /*}*/

    /*.question-option:hover,.active{*/
      /*background: url("check-bule.png") left no-repeat;*/
      /*background-size: 25px;*/
      /*border: 2px solid #5571EC;*/
      /*border-radius: 50px;*/
    /*}*/
    /*.content-question  .btn-complete,.content-question .btn-back{*/
      /*margin-top: 30px;*/
      /*width: 100px;*/
      /*height: 35px;*/
      /*font-size: 20px;*/
    /*}*/
    /*.content-question .question-detail .question-option{*/
      /*min-width: 40%;*/
    /*}*/

    .the-ipad-min{
      width: 100%;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/commonSense/commonSense.vue